export default ({ request }) => ({
    ecomEvgCombineListApi(data = {}) {
        return request({
            url: '/ecom/evg/combine/list',
            method: 'post',
            data,
        })
    },
    ecomEvgCombineDetailApi(data = {}) {
        return request({
            url: '/ecom/evg/combine/detail',
            method: 'post',
            data,
        })
    },
    ecomEvgCombineSaveApi(data = {}) {
        return request({
            url: '/ecom/evg/combine/save',
            method: 'post',
            data,
        })
    },
    ecomEvgCombineDelApi(data = {}) {
        return request({
            url: '/ecom/evg/combine/del',
            method: 'post',
            data,
        })
    },
    ecomEvgCombineFullMemberApi(data = {}) {
        return request({
            url: '/ecom/evg/combine/fullMember',
            method: 'post',
            data,
        })
    },

})
